/**
 * MultiCartIcon Component
 *
 * Cart icon for the header that shows total item count across all merchant carts.
 * Opens the MultiCartDrawer when clicked.
 *
 * @story MCART-8
 */

import { ActionIcon, Indicator, Skeleton, Tooltip } from '@mantine/core';
import { IconShoppingCart } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useMultiCartContext } from '@/features/cart';

export function MultiCartIcon() {
  const { t } = useTranslation('common');
  const { totalItems, isLoading, openDrawer } = useMultiCartContext();

  if (isLoading) {
    return <Skeleton circle width={32} height={32} />;
  }

  return (
    <Tooltip label={t('my_carts')}>
      <Indicator
        disabled={totalItems === 0}
        label={totalItems > 99 ? '99+' : totalItems}
        size={16}
        offset={4}
        color="teal.8"
      >
        <ActionIcon
          variant="subtle"
          size="lg"
          onClick={openDrawer}
          aria-label={t('my_carts')}
          data-testid="multicart-btn"
        >
          <IconShoppingCart size={20} stroke={1.5} />
        </ActionIcon>
      </Indicator>
    </Tooltip>
  );
}
